<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title flex-1 is-size-5 has-text-centered">{{
        General.CHANGE_REGISTER_DOE
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <b-field
          :label="General.PUBLICATION_DATE"
          class="column is-12 mb-0 pb-0"
          customClass="has-text-color-7"
        >
          <div class="column is-6 px-0">
            <b-dropdown ref="dateDropdown" :disabled="filled" expanded>
              <template slot="trigger">
                <b-button
                  expanded
                  iconLeft="calendar"
                  class="custom-dropdown-button is-justify-content-flex-start"
                >
                  <span v-if="dateRange">{{
                    dateRange | dateFormat("DD/MM/YYYY")
                  }}</span>
                  <span v-else>{{ General.SELECET_PUBLICATION_DATE }}</span>
                </b-button>
              </template>
              <b-dropdown-item custom>
                <DatePicker
                  :locale="locationConfig"
                  :value="dateRange"
                  :isDark="isContrast"
                  :modelConfig="modelConfig"
                  :maxDate="new Date()"
                  @dayclick="onDayClick"
                />
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-field>
        <b-field class="column is-12">
          <div class="is-flex is-flex-direction-column">
            <div class="simple-row">
              <span class="has-text-weight-semibold has-text-color-7">
                {{ General.NOTES }}
              </span>
            </div>
            <b-input
              v-model="message"
              :disabled="filled"
              maxlength="200"
              type="textarea"
              :placeholder="General.OBSERVATION_DOE_PUBLISH"
            ></b-input>
          </div>
        </b-field>
        <div class="list-container spacing-mb-30">
          <section v-if="!filled" class="is-flex is-justify-content-flex-end">
            <div class="buttons">
              <b-button
                :type="isContrast ? 'is-white' : 'is-primary'"
                @click="confirmAction"
              >
                {{ General.SAVE.toUpperCase() }}
              </b-button>
            </div>
          </section>

          <b-table
            class="custom-table-process-panel custom-3-columns-doe mt-10"
            :data="listDocuments"
            role="table"
          >
            <template>
              <b-table-column v-slot="props" :label="General.NUP">
                {{ applyMaskNUP(props.row.process_file.nup) }}
              </b-table-column>
              <b-table-column v-slot="props" :label="General.DOCUMENT">
                {{ props.row.process_file.attachment_name }}
              </b-table-column>
              <b-table-column v-slot="props" :label="General.TYPE">
                {{ props.row.process_file.document_type }}
              </b-table-column>
            </template>
          </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { NUP, applyMask } from "@/utils/protocols";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

import { App, General } from "@/utils/constants";

export default {
  name: "ModalChangePublishDoe",
  components: {
    DatePicker
  },
  props: {
    listDocuments: {
      type: Array,
      default: () => []
    },
    clearSelection: {
      type: Function,
      default: () => null
    },
    onClose: {
      type: Function,
      default: () => null
    },
    isHistory: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      needDate: true,
      reason_option: "",
      message: "",
      locationConfig: Object.freeze({
        id: "pt-br",
        firstDayOfWeek: 1,
        masks: { input: `YYYY-DD-MM` }
      }),
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        }
      },
      dateRange: null
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    filled() {
      return Boolean(this.listDocuments[0].publish_date) && this.isHistory;
    }
  },

  beforeMount() {
    if (this.listDocuments[0]?.publish_date)
      this.dateRange = new Date(this.listDocuments[0].publish_date);
    if (this.listDocuments[0].publish_date && this.isHistory) {
      this.message = this.listDocuments[0].observation;
    }
  },

  methods: {
    ...mapActions({
      publish: "doePublish",
      doeProgrammed: "doeProgrammedRequest",
      doePublished: "doePublishedRequest"
    }),

    async confirmAction() {
      if (this.dateRange && this.message) {
        this.isLoading = true;
        const listDocumentsPublication = this.listDocuments.map(document => ({
          doe_process_file_id: document.id,
          process_file_id: document.process_file.id,
          publish_date: this.dateRange,
          program_date: new Date(document.program_date),
          observation: this.message
        }));

        await this.publish(listDocumentsPublication);
        await this.doeProgrammed({
          page: 1,
          paginator_count: 10
        });
        await this.doePublished({
          page: 1,
          paginator_count: 10
        });
        this.isLoading = false;
        this.close();
        this.onClose();
      } else {
        this.snackToast.open({
          message: this.General.EMPTY_FIELD_REQUIRED,
          type: "is-danger",
          duration: 8000
        });
      }
    },

    close() {
      this.clearSelection();
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    onDayClick(day) {
      if (day?.date < new Date()) {
        this.dateRange = day.date;
        this.$refs["dateDropdown"]?.toggle();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 650px;
  max-width: 75vw;
  min-height: 300px;
  max-height: 75vh;
  background-color: $color-1;
  @media screen and (max-width: $tablet) {
    max-width: 100vw;
  }
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
}

.dropdown-item:hover {
  background-color: $color-1 !important;
}
</style>
